import mutationTypes from "@/vuex/mutation-types";
import actionTypes from "@/vuex/action-types";
import SecureApiService from "@/services/api/secureApiService";
import * as constants from "@/common/constants";

const secureApiService = new SecureApiService();

const getDefaultState = () => {
  return {
    status: "",

    profileLoaded: false,

    profileId: "",
    profileEmail: "",
    profileAvatar: "",
    profileFirstName: "",
    profileLastName: "",
    profileState: "",
    profileScopes: [],

    getProfileError: ""
  };
};

const initialState = getDefaultState();

const mutations = {
  [mutationTypes.RESET_STATE](state) {
    Object.assign(state, getDefaultState());
  },
  [mutationTypes.PROFILE_REQUEST](state) {
    state.status = constants.STATUS_LOADING;
    state.getProfileError = "";
  },
  [mutationTypes.PROFILE_SUCCESS](state, profileData) {
    state.status = constants.STATUS_SUCCESS;
    state.profileLoaded = true;
    state.profileId = profileData.id;
    state.profileEmail = profileData.email;
    state.profileAvatar = profileData.avatar_url;
    state.profileFirstName = profileData.name;
    state.profileLastName = profileData.last_name;
    state.profileState = profileData.state;
    state.profileScopes = profileData.scopes;
  },
  [mutationTypes.PROFILE_ERROR](state, error) {
    state.status = constants.STATUS_ERROR;
    state.getProfileError = error;
  }
};

const getters = {
  profileStatus: state => state.status,
  profileLoaded: state => state.profileLoaded,
  profileId: state => state.profileId,
  profileEmail: state => state.profileEmail,
  profileAvatar: state => state.profileAvatar,
  profileFirstName: state => state.profileFirstName,
  profileLastName: state => state.profileLastName,
  profileState: state => state.profileState,
  profileScopes: state => state.profileScopes,
  profileError: state => state.getProfileError
};

const actions = {
  [actionTypes.GET_PROFILE]({ commit }) {
    return secureApiService
      .getProfile()
      .then(profileData => {
        commit(mutationTypes.PROFILE_SUCCESS, profileData);
      })
      .catch(err => {
        commit(mutationTypes.PROFILE_ERROR, err);
      });
  }
};

export default {
  state: initialState,
  getters,
  actions,
  mutations
};
